// Global Instructions Rule Applied!

import {
  FieldConfig,
  TextFieldConfig,
  NumberFieldConfig,
  SelectFieldConfig,
  TextareaFieldConfig,
  CompanyFieldConfig,
  CountryFieldConfig,
  CityFieldConfig,
  ContactFieldConfig,
  ValuationFieldConfig,
  DateFieldConfig,
  TimeFieldConfig,
  RichTextFieldConfig,
  SwitchFieldConfig,
  CheckboxFieldConfig,
  DealFieldConfig,
  ProspectFieldConfig,
  TagsFieldConfig,
  FieldTypeEnum
} from '../types.ts'

export function isTextFieldConfig(config: FieldConfig): config is TextFieldConfig {
  return (
    config.type === FieldTypeEnum.TEXT ||
    config.type === FieldTypeEnum.TEXT_ACTION ||
    config.type === FieldTypeEnum.LINK ||
    config.type === FieldTypeEnum.URL ||
    config.type === FieldTypeEnum.EMAIL ||
    config.type === FieldTypeEnum.PHONE
  )
}

export function isNumberFieldConfig(config: FieldConfig): config is NumberFieldConfig {
  return config.type === FieldTypeEnum.NUMBER || config.type === FieldTypeEnum.CURRENCY
}

export function isSelectFieldConfig(config: FieldConfig): config is SelectFieldConfig {
  return config.type === FieldTypeEnum.SELECT
}

export function isTextareaFieldConfig(config: FieldConfig): config is TextareaFieldConfig {
  return config.type === FieldTypeEnum.TEXTAREA
}

export function isCompanyFieldConfig(config: FieldConfig): config is CompanyFieldConfig {
  return config.type === FieldTypeEnum.COMPANY
}

function isCountryFieldConfig(config: FieldConfig): config is CountryFieldConfig {
  return config.type === FieldTypeEnum.COUNTRY
}

export function isCityFieldConfig(config: FieldConfig): config is CityFieldConfig {
  return config.type === FieldTypeEnum.CITY
}

export function isContactFieldConfig(config: FieldConfig): config is ContactFieldConfig {
  return config.type === FieldTypeEnum.CONTACT
}

export function isValuationFieldConfig(config: FieldConfig): config is ValuationFieldConfig {
  return config.type === FieldTypeEnum.VALUATION
}

export function isDateFieldConfig(config: FieldConfig): config is DateFieldConfig {
  return config.type === FieldTypeEnum.DATE
}

export function isTimeFieldConfig(config: FieldConfig): config is TimeFieldConfig {
  return config.type === FieldTypeEnum.TIME
}

export function isRichTextFieldConfig(config: FieldConfig): config is RichTextFieldConfig {
  return config.type === FieldTypeEnum.RICHTEXT
}

export function isSwitchFieldConfig(config: FieldConfig): config is SwitchFieldConfig {
  return config.type === FieldTypeEnum.SWITCH
}

export function isCheckboxFieldConfig(config: FieldConfig): config is CheckboxFieldConfig {
  return config.type === FieldTypeEnum.CHECKBOX
}

export function isDealFieldConfig(config: FieldConfig): config is DealFieldConfig {
  return config.type === FieldTypeEnum.DEAL
}

export function isProspectFieldConfig(config: FieldConfig): config is ProspectFieldConfig {
  return config.type === FieldTypeEnum.PROSPECT
}

export function isTagsFieldConfig(config: FieldConfig): config is TagsFieldConfig {
  return config.type === FieldTypeEnum.TAGS
}
